import { getStepTypes, getProductJson } from "./utilities";
import {state} from './state';
import bb from 'blingblingjs';

export async function createStepData(
    dataset,
    product
) {


    const stepTypes = getStepTypes(); 
    const newChosenOptions = [];
    const newStepData = [];
    let isCurrentStep = false;
    let returnProduct = product;

    
    for (const [index, stepType] of stepTypes.entries()) {
        
        isCurrentStep = index == getStepIndex(dataset.step) ? true : false;
        if (stepType.type == "custom") {
            newStepData.push({}); 
            if(isCurrentStep) newChosenOptions.push(createCustomStepChoice(dataset)); 
            else newChosenOptions.push(state.chosenOptions[index]);
        }
        if (stepType.type == "tag") {
            newStepData.push(getTagStepOptions(index)); 
            if(isCurrentStep) newChosenOptions.push(createTagStepChoice(dataset)); 
            else newChosenOptions.push(state.chosenOptions[index]);
        }
        if (stepType.type == "root") {
            newStepData.push(getRootStepOptions(index)); 
            if(isCurrentStep) newChosenOptions.push(createRootStepChoice(product)); 
            else {
                const [ rootChoice, newProduct ] = await getValidRootStepChoice(stepTypes, newStepData, newChosenOptions, state.chosenOptions, index);
                returnProduct = newProduct ? newProduct : product;
                newChosenOptions.push(rootChoice);
            }
        }
        if (stepType.type == "option") {
            newStepData.push(getStepOptions(returnProduct.product.variants, stepTypes[index].shopifyVariantOption, getRequiredOptionMatches(newChosenOptions)) ); 
            if(isCurrentStep) newChosenOptions.push(createOptionStepChoice(dataset)); 
            else newChosenOptions.push(getValidOptionStepChoice(newStepData[index], state.chosenOptions[index], stepType.defaultValue));
        }
        if (stepType.type == "splitOption") {
            newStepData.push(getStepSplitOptions(returnProduct.product.variants, stepTypes[index].shopifyVariantOption, getRequiredOptionMatches(newChosenOptions)) ); 
            if(isCurrentStep) newChosenOptions.push(createSplitOptionStepChoice(dataset, state.chosenOptions[index], newStepData[index])); 
            else newChosenOptions.push(getValidSplitOptionStepChoice(newStepData[index], state.chosenOptions[index]));
        }

    }

    return [
        newChosenOptions,
        newStepData,
        returnProduct
    ]
    

}

function getStepIndex(step){
    return step - 1;
}


function createCustomStepChoice(dataset){
    return {value : dataset.value.toLowerCase() , title : dataset.title}
}

function createTagStepChoice(dataset){
    return {value : dataset.value.toLowerCase() , title : dataset.title}
}

function createRootStepChoice(product){
    return {
        value: product.product.id,
        title: product.product.title
    };
}

function createOptionStepChoice(dataset) {
    return {
        value: dataset.value.toLowerCase() ,
        title: dataset.title
    };
}

function createSplitOptionStepChoice(dataset, currentChoice, stepData) {

    // The primary choice is either valid by default, or the option we are choosing
    const primaryChoice = Number(dataset.splitoption) == 2 ? currentChoice[0] : {title : dataset.title, value : dataset.value.toLowerCase() };

    const secondaryChoiceOptions = stepData[1][stepData[0].indexOf(primaryChoice.value)];

    let secondaryChoice;

    if( dataset.splitoption == Number(2) ) {
        secondaryChoice = {title : dataset.title, value : dataset.value.toLowerCase()};
    } else {
        if(secondaryChoiceOptions.includes(currentChoice[1].value)){
            secondaryChoice = currentChoice[1];
        }
        else {
            secondaryChoice = { title : secondaryChoiceOptions[0], value : secondaryChoiceOptions[0].toLowerCase()  }
        }
    }

    return [primaryChoice, secondaryChoice];
}


function getRequiredOptionMatches(chosenOptions){
    return chosenOptions.map((item, index) => {

        const value = getStepTypes()[index].type == 'option' ? chosenOptions[index].value : getStepTypes()[index].type == 'splitOption' ? chosenOptions[index][0].value + '/' + chosenOptions[index][1].value : null;
                        
        return { 
            shopifyVariantOption : getStepTypes()[index].shopifyVariantOption, 
            value : value 
        };
    }).filter(item => item.shopifyVariantOption)
}

function getValidRootStepChoice(stepTypes, newStepData, newChosenOptions, currentChosenOptions, index){

 
    let hasTagStep = false;

    return new Promise((res) => {
        stepTypes.forEach( async (step, i) => {

            // if there is a 'tag' step
            if(step.type == 'tag') {
    
                hasTagStep = true;
    
                const currentTag = newChosenOptions[i].value.toLowerCase();
                const thisProduct = newStepData[index].find(item => item.id == currentChosenOptions[index].value)
                if(thisProduct && thisProduct.productTags.includes(currentTag)){
                    res([currentChosenOptions[index]])
                } 
                else {
                    const handle = newStepData[index].find(item => item.productTags && item.productTags.includes(currentTag)).productHandle
                    const product = await getProductJson(handle);
                    res([createRootStepChoice(product), product]) 
                }
            } 
        });

        if(!hasTagStep) {
            res([currentChosenOptions[index]])
        }
        
    })

}


function getValidOptionStepChoice(stepData, currentChoice, defaultValue){

    if(stepData.includes(currentChoice.value)) {
        return currentChoice
    } else if (defaultValue && stepData.includes(defaultValue)){
        return {
            title : defaultValue,
            value : defaultValue
        }
    }
    else {
        return {
            title : stepData[0],
            value : stepData[0]
        }
    }
}

function getValidSplitOptionStepChoice(stepData, currentChoice){

    const primaryChoice = currentChoice && stepData[0].includes(currentChoice[0]?.value) ? currentChoice[0] : {title : stepData[0][0], value : stepData[0][0]};

    const secondaryChoiceOptions = stepData[1][stepData[0].indexOf(primaryChoice.value)];

    let secondaryChoice;

    if(currentChoice && secondaryChoiceOptions.includes(currentChoice[1]?.value)) {
        secondaryChoice = currentChoice[1]
    } else {
        secondaryChoice = {
            title : secondaryChoiceOptions[0],
            value : secondaryChoiceOptions[0]
        }   
    }

    return [
        primaryChoice,
        secondaryChoice
    ]
}

function getStepOptions(variants, key, requiredOptionMatches) {

    const options = new Set();
    variants.forEach(variant => {
        if(requiredOptionMatches.every(match => {
            return variant[match.shopifyVariantOption].toLowerCase() == match.value.toLowerCase()
        })) {
            options.add(variant[key].toLowerCase());
        }
    });
    return [...options];
}

function getStepSplitOptions(variants, key, requiredOptionMatches){
    
    const primaryOptions = [];
    let secondaryOptions = [];

    variants.forEach(variant => {

        if(requiredOptionMatches.every(match => variant[match.shopifyVariantOption] == match.value )) {

            // Convert the option to an array
            let optionPair = variant[key].split("/");

            if (!primaryOptions.includes(optionPair[0]))
                primaryOptions.push(optionPair[0].toLowerCase());

            const indexOfPrimary = primaryOptions.indexOf(optionPair[0]);

            if (!secondaryOptions[indexOfPrimary])
                secondaryOptions[indexOfPrimary] = new Set();

            secondaryOptions[indexOfPrimary].add(optionPair[1].toLowerCase());
        }
    });

    secondaryOptions = secondaryOptions.map(optionSet => [...optionSet]);

    return [primaryOptions, secondaryOptions];
    
}



function createDefaultCustomOption(step, providedChoice){
    const defaultValue = step.defaultValue;
    const providedValue = providedChoice ? providedChoice : false;

    if (providedValue) {
        return { title : providedValue, value : providedValue }
    } 
    else if (defaultValue) {
        return { title : defaultValue, value : defaultValue } 
    } 
    else {
        return { title : '', value : '' } 
    } 
}

function createDefaultTagOption(options, product){
    const choice = product.product.tags.split(',').map(item => item.trim().toLowerCase()).find(tag => {
        return options.includes(tag)
    })

    return {
        title : choice, value : choice
    }
}

function createDefaultOption(step, variant, product, providedValue, stepData){

    const variantMatch = variant && product.product.variants.find(_variant => _variant.id == variant);
    const hasProvidedValueMatch = providedValue && stepData.includes(providedValue.toLowerCase());

    if (hasProvidedValueMatch) {
        return { title : providedValue, value : providedValue.toLowerCase() }
    }
    if (variantMatch) {
        return { title : variantMatch[step.shopifyVariantOption], value : variantMatch[step.shopifyVariantOption].toLowerCase()}
    } 
    
    return { title : product.product.variants[0][step.shopifyVariantOption] , value : product.product.variants[0][step.shopifyVariantOption].toLowerCase()}

}

function createDefaultSplitOption(step, variant, product, stepData){

    // If a variant is supplied, use that
    const variantMatch = variant && product.product.variants.find(_variant => _variant.id == variant);
    if (variantMatch) {
        return variantMatch[step.shopifyVariantOption].split("/").map(item => ({title : item, value : item}))
    }

    return getValidSplitOptionStepChoice(stepData, [])
    
}


export function getInitialStepData(
    product,
    variant, 
    providedChoices
) {
    const stepTypes = getStepTypes();
    const newChosenOptions = [];
    const newStepData = [];
    
    

    stepTypes.forEach((stepType,index) => {
        if (stepType.type == "custom") {
            newStepData.push({}); 
            newChosenOptions.push(
                createDefaultCustomOption(stepType, providedChoices[index])
            );
        }
        if (stepType.type == "tag") {
            newStepData.push(getTagStepOptions(index)); 
            newChosenOptions.push(
                createDefaultTagOption(newStepData[index],product)
            );
        }
        if (stepType.type == "root") {
            newStepData.push(getRootStepOptions(index)); 
            newChosenOptions.push(createRootStepChoice(product));
        }
        if (stepType.type == "option") {
            newStepData.push(getStepOptions(product.product.variants, stepTypes[index].shopifyVariantOption, getRequiredOptionMatches(newChosenOptions)) ); 
            newChosenOptions.push(createDefaultOption(stepType, variant, product, providedChoices[index], newStepData[index]));
        }
        if (stepType.type == "splitOption") {
            newStepData.push(getStepSplitOptions(product.product.variants, stepTypes[index].shopifyVariantOption, getRequiredOptionMatches(newChosenOptions)) ); 
            newChosenOptions.push(createDefaultSplitOption(stepType, variant, product, newStepData[index]));
        }
    });

    return {
        newChosenOptions,
        newStepData
    }
}


function getTagStepOptions(index){
    // get all the root products
    const tags = []
    bb('.js-el__configurator-option').forEach(option => {
        if(option.dataset.step == index + 1) {
            tags.push(option.dataset.value.toLowerCase())
        }
    });

    return tags
}



function getRootStepOptions(index) {
    
    // get all the root products
    const rootItems = []
    bb('.js-el__configurator-option').forEach(option => {
        
        if(option.dataset.step == index + 1) {
            rootItems.push({
                productHandle : option.dataset.productHandle,
                id : option.dataset.value.toLowerCase(),
                productTags : option.dataset.productTags && option.dataset.productTags.split(',').map(item => item.trim().toLowerCase()),                      
            })
        }
    })

    return rootItems;
    
}